/**
 * Shared HTTP helpers used by API composables.
 */

type FetchFn = (url: string, options?: RequestInit) => Promise<Response>;

export async function apiGet<T>(url: string, fetchFn: FetchFn = fetch): Promise<T> {
  const response = await fetchFn(url);
  if (!response.ok) throw new Error(`GET ${url} failed: ${response.status}`);
  return response.json() as Promise<T>;
}

export async function apiSend<T>(
  method: string,
  url: string,
  body?: unknown,
  fetchFn: FetchFn = fetch,
): Promise<T> {
  const response = await fetchFn(url, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (response.ok) {
    return response.json() as Promise<T>;
  }

  let detail = '';
  try {
    const text = await response.text();
    const parsed = JSON.parse(text);
    detail = JSON.stringify(parsed, null, 2);
  } catch {
    /* response body wasn't JSON — leave detail empty */
  }
  const message = `${method} ${url} failed: ${response.status}`;
  const suffix = detail ? ` — ${detail}` : '';
  throw new Error(message + suffix);
}
